module.exports = __webpack_public_path__ + "static/media/erasmus20.480652a4.jpg";